import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactModel } from '../../../contact/models/contact.model';
import {
  OriginContactType,
  OriginContactTypeOption,
  OriginContactVm,
} from '../../models/origin-contact.model';

/**
 * Präsentationale Kontaktliste für den Herkunft-Step. Kapselt den zuvor mehrfach
 * duplizierten Kontakt-Accordion. Der State (originContacts) und die eigentlichen
 * Handler leben weiterhin im AnimalAddDialogComponent; diese Komponente rendert nur
 * und emittiert die Nutzeraktionen.
 */
@Component({
  selector: 'app-origin-contacts',
  templateUrl: './origin-contacts.component.html',
  standalone: false,
})
export class OriginContactsComponent {
  @Input() contacts: OriginContactVm[] = [];
  @Input() typeOptions: OriginContactTypeOption[] = [];

  /** true = mehrere Panels gleichzeitig offen (delivery/takeover/...), false = einzeln (Fundtier). */
  @Input() multiple = true;
  /** Für den Single-Mode: aktuell geöffnetes Panel (Index als String), null = keins offen. */
  @Input() activePanel: string | null = '0';
  /** Optionale Überschrift links neben dem "Hinzufügen"-Button. */
  @Input() headline: string | null = null;
  /** "Primary"-Badge im Panel-Header anzeigen (Übernahme aus Tierheim). */
  @Input() showPrimaryBadge = false;
  /** Hinweistext anzeigen, wenn keine Kontakte vorhanden sind. */
  @Input() showEmptyState = true;

  @Output() activePanelChange = new EventEmitter<string | null>();
  @Output() add = new EventEmitter<void>();
  @Output() remove = new EventEmitter<number>();
  @Output() typeChanged = new EventEmitter<{ index: number; type: OriginContactType }>();
  @Output() labelChanged = new EventEmitter<{ index: number; label: string }>();
  @Output() validationChanged = new EventEmitter<{ index: number; valid: boolean }>();
  @Output() newContactUpdated = new EventEmitter<{ index: number; contact: ContactModel }>();
  @Output() existingSelected = new EventEmitter<{ index: number; contact: ContactModel }>();

  getTypeLabel(type: OriginContactType): string {
    return this.typeOptions.find(x => x.value === type)?.label ?? type;
  }

  trackByContact = (index: number, vm: OriginContactVm) =>
    `${index}-${vm.ref.type}-${vm.contact?.id ?? 'new'}`;
}
